import { CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "./FilterAgentSearch.scss";
import { PropertyApi } from "../../../../utils/api/Property";
import { getAgentId, getImageUrl } from "../../../../utils/helpers/common";
import SearchIcon from "../../../../components/icons/SearchIcon";
import DownArrowIcon from "../../../../components/icons/DownArrowIcon";
import CloseIcon from "../../../../components/icons/CloseIcon";
import { AgencyApi } from "../../../../utils/api/Agency";

interface FilterAgentSearchProps {
  formik: any;
}

const FilterAgentSearch = ({ formik }: FilterAgentSearchProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const searchTimeout = useRef<NodeJS.Timeout | null>(null);

  const [search, setSearch] = useState("");

  const [state, setState] = useState({
    agentListBox: false,
    agentsList: [] as any[],
    isLoading: true,
  });

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setState((prev) => ({
          ...prev,
          agentListBox: false,
        }));
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  const onToggelBox = () => {
    setState((prev) => ({
      ...prev,
      agentListBox: !prev.agentListBox,
    }));
  };

  const onOpenBox = () => {
    setState((prev) => ({
      ...prev,
      agentListBox: true,
    }));
  };

  const onClickSelect = (id: string) => {
    const selectedAgent = state.agentsList.find((agent) => agent._id === id);

    const currentIds = formik?.values?.selectedAgentIds || [];
    const newIds = [...currentIds, id];

    const currentObjects = formik?.values?.agentObjects || [];
    const newObjects = selectedAgent
      ? [...currentObjects, selectedAgent]
      : currentObjects;

    formik.setFieldValue("selectedAgentIds", newIds);
    formik.setFieldValue("agentObjects", newObjects);

    setState((prev) => ({
      ...prev,
      agentListBox: false,
    }));
  };

  const onClickRemove = (id: string) => {
    const resultIds = formik?.values?.selectedAgentIds.filter(
      (_id: string) => _id !== id,
    );

    const resultObjects = (formik?.values?.agentObjects || []).filter(
      (agent: any) => agent._id !== id,
    );

    formik.setFieldValue("selectedAgentIds", resultIds);
    formik.setFieldValue("agentObjects", resultObjects);
  };

  const getDataApi = async (searchValue = "") => {
    setState((prev) => ({
      ...prev,
      isLoading: true,
    }));

    const res = await AgencyApi.getAgents(searchValue);

    if (res?.data?.success) {
      const filterResult = res?.data?.data?.docs.filter(
        (data: any) => data?.id !== getAgentId(),
      );

      setState((prev) => ({
        ...prev,
        isLoading: false,
        agentsList: filterResult,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        isLoading: false,
      }));
      toast.error(res?.data?.message);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      getDataApi(value);
    }, 500);
  };

  const agentCheck = (id: string) => {
    return formik?.values?.selectedAgentIds?.includes(id);
  };

  useEffect(() => {
    getDataApi();
  }, []);

  return (
    <div className="agent-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Agent</p>
      </div>

      <div className="filter-search-agent">
        <div className="filter-search-icon">
          <SearchIcon />
        </div>
        <input
          type="text"
          placeholder="Search agents"
          className="filter-search-input"
          value={search}
          onChange={handleSearch}
          onClick={onOpenBox}
          onFocus={onOpenBox}
        />
        <div
          className={`filter-down-arrow-icon ${
            state?.agentListBox ? "open-box" : ""
          }`}
          onMouseDown={(e) => {
            e.preventDefault();
            onToggelBox();
          }}
        >
          {state?.isLoading ? (
            <CircularProgress
              style={{
                width: 20,
                height: 20,
                color: "black",
                marginTop: "-2px",
              }}
            />
          ) : (
            <DownArrowIcon />
          )}
        </div>
      </div>
      <div className="selected-agent-contain">
        {state?.agentsList?.map((data: any) => {
          if (agentCheck(data?._id)) {
            return (
              <div className={`selected-agent`} key={data?._id}>
                <div className="selected-agent-profile-details">
                  <div className="selected-agent-profile-img">
                    <img
                      src={getImageUrl(
                        data?.profile_image_ref?.compressed_file_path,
                      )}
                      alt=""
                    />
                  </div>

                  <p className="selected-agent-profile-name">{`${data?.principal_agent_first_name} ${data?.principal_agent_last_name}`}</p>
                </div>
                <div
                  className="selected-agent-remove-icon"
                  onClick={() => onClickRemove(data?._id)}
                >
                  <CloseIcon />
                </div>
              </div>
            );
          }
        })}
      </div>

      <div
        className={`agent-list-container ${
          state?.agentListBox ? "" : "display-none"
        }`}
      >
        {state?.agentsList?.length ? (
          state?.agentsList?.map((data: any) => (
            <div
              className={`agent-list-item ${
                agentCheck(data?._id) ? "agent-list-item-active" : ""
              }`}
              key={data?._id}
              onClick={() => onClickSelect(data?._id)}
            >
              <div className="item-profile-img">
                <img
                  src={getImageUrl(
                    data?.profile_image_ref?.compressed_file_path,
                  )}
                  alt=""
                />
              </div>
              <p className="item-profile-name">{`${data?.principal_agent_first_name} ${data?.principal_agent_last_name}`}</p>
            </div>
          ))
        ) : (
          <div className="agent-list-not-found">
            <p>Agents not found!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterAgentSearch;
